export default Object.freeze({
  GET_POLLS: "GET_POLLS",
  GET_ALERTS: "GET_ALERTS",
  GET_POSTS: "GET_POSTS",
  SET_SUBMITED_POLL: "SET_SUBMITED_POLL",
  SET_HIDDEN_POLLS: "SET_HIDDEN_POLLS",
  LOAD_MORE_POSTS: "LOAD_MORE_POSTS"
});
